import { Promotion } from '../../../../stores/promotion';
import style from '../../style.module.scss';

const renderActivationCount = (_: unknown, record: Promotion) => {
    if (
        record.type !== 'coupon' ||
        record.quantity == null ||
        record.quantity <= 0
    ) {
        return <span className={style.not_applicable}>-</span>;
    }

    return (
        <span className={style.minimal_badge}>
            <span className={style.count_number}>
                {record.activationsCount || 0}
            </span>
            <span className={style.count_separator}>/</span>
            <span className={style.count_total}>{record.quantity}</span>
        </span>
    );
};

export default renderActivationCount;
